let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ibavr")).then(() => parcelRequire('aNYOV'));